import React from 'react'
import PaginationFooter from "./pagination-footer";

export default function TableFooter({ colSpan, query, updatePagination }) {
  return (
    <table className='min-w-full'>
      <tfoot className="bg-gray-50 sticky bottom-0 z-10">
      <tr>
        <td colSpan={colSpan} className='px-6 py-4 text-center'>
          <PaginationFooter
            pagination={query}
            updatePagination={updatePagination}
          />
        </td>
      </tr>
      </tfoot>
    </table>
  )
}
